import React from 'react';
import { TextField } from '@mui/material';


export default function SalonProposalExpiryField({
  value = 24,
  onChange,
  label,
  helperText,
  disabled = false,
}) {
  return (
    <TextField
      type="number"
      label={label}
      value={value}
      inputProps={{ min: 1, max: 720 }}
      onChange={(event) => onChange(Number(event.target.value))}
      helperText={helperText}
      disabled={disabled}
      fullWidth
    />
  );
}
